import { Skeleton } from "@volca/ui/components/ui/skeleton";
import { Stack } from "@volca/ui/components/ui/stack";
import { BusinessSettingsSidebarWrapper } from "@/business-settings/common/business-settings-sidebar-wrapper";

export const TextMessagesSidebarSkeleton = () => (
  <BusinessSettingsSidebarWrapper>
    <Stack
      gap={4}
      direction="column"
      justify="between"
      align="start"
      className="w-full shrink-0 px-6 pt-5 pb-4"
    >
      <Skeleton className="h-[26px] w-[86px]"></Skeleton>
      <Stack align="start" gap={4}>
        <Skeleton className="h-2 w-10"></Skeleton>
        <Skeleton className="h-3 w-20"></Skeleton>
      </Stack>
    </Stack>
  </BusinessSettingsSidebarWrapper>
);
